import { firebaseAction } from 'vuexfire'
import db from '@/plugins/db'

// initial state
const state = {
  notification: '',
}

// getters
const getters = {
  getText: (state) => () => {
    if (!state) return undefined
    if (!state.notification) return undefined

    return state.notification.text
  },
}

// actions
const actions = {
  bindNotification: firebaseAction(context => {
    return context.bindFirebaseRef('notification', db.ref('notification'))
  }),
  setText: ({ commit }, newText) => {
    db.ref(`notification`).update(newText)
  },
}

// mutations
const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
